import * as React from 'react';
import { ICON_SIZE_MAP } from '../helpers/size.js';
const ExitFullscreenIcon = React.forwardRef((props, ref) => {
    const sizeKey = props.size !== undefined ? props.size : 1;
    const size = ICON_SIZE_MAP[sizeKey];
    return (React.createElement("svg", { width: size, height: size, fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, viewBox: "0 0 16 16" },
        React.createElement("path", { d: "M.381 10.857H3.81L0 14.667 1.333 16l3.81-3.81v3.429h1.905V8.952H.38v1.905ZM14.667 0l-3.81 3.81V.38H8.952v6.667h6.667V5.143h-3.428L16 1.333 14.667 0Z", fill: "currentColor" })));
});
ExitFullscreenIcon.displayName = 'ExitFullscreenIcon';
export default ExitFullscreenIcon;
